import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { KeplerMatch } from '../../models/KeplerMatch';

@Component({
  selector: 'lms-kepler-notification-list',
  templateUrl: './kepler-notification-list.component.html',
  styleUrls: ['./kepler-notification-list.component.scss']
})
export class KeplerNotificationListComponent implements OnInit, OnChanges {
  @Input() match: KeplerMatch;
  public keplerMatchEmailsListId = 'KEPLER_MATCH_EMAILS_LIST';
  public filters: Object;
  public toolbarConfig: any;
  public timezone: any;

  constructor() {}

  ngOnInit(): void {
    this.toolbarConfig = {
      list: {
        listId: this.keplerMatchEmailsListId,
        download: true,
        filterRow: false,
        columnChooser: false,
        skeletor: true
      }
    };
    this.timezone = this.match.timezone;
  }

  async ngOnChanges() {
    this.filters = { matchId: this.match.id };
  }
}
